/*******************************************************************************
  설  명 : 검사표 복사 — 타 시설 검사표 선택 모달
  비  고 : 목록/복사저장 API는 백엔드에서 구현 예정
*******************************************************************************/
import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ReceptionService } from '@app/service/reception.service';
import { ToastrService } from 'ngx-toastr';

/** ngbModal open 시 windowClass로 함께 지정 — 다이얼로그 폭·리스트 폰트용 */
export const MODAL_INSPECT_REPORT_COPY_WINDOW_CLASS = 'modal-inspect-report-copy-dialog';

@Component({
  selector: 'app-modal-inspect-report-copy',
  templateUrl: './modal-inspect-report-copy.component.html',
  styleUrls: ['./modal-inspect-report-copy.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ModalInspectReportCopyComponent implements OnInit {

  /** 부모 화면(선택 검사접수)의 업체코드 기본값 — 기본 검색에는 시설코드 미포함 */
  @Input() defaultCompanyCode: string;

  /** 복사 대상(현재 화면) 접수 seq — 검사표가 복사되어 들어갈 접수 */
  @Input() targetReceptionSeq: any;

  /** 조회 조건 */
  searchCompanyCode = '';
  searchFacilityCode = '';

  /** 목록 (API data 배열) */
  list: any[] = [];
  /** 단일 선택 행 — 복사 시 reportSeq(원본 접수 seq) 전달 */
  selectedRow: any = null;

  loading = false;
  copying = false;

  constructor(
    public activeModal: NgbActiveModal,
    private receptionService: ReceptionService,
    private toastrService: ToastrService,
  ) {}

  ngOnInit() {
    this.searchCompanyCode = this.defaultCompanyCode != null ? String(this.defaultCompanyCode) : '';
    this.searchFacilityCode = '';
    if (this.hasAtLeastOneSearchField()) {
      this.loadList();
    }
  }

  /** 업체코드·시설코드 중 하나라도 입력되었는지 */
  private hasAtLeastOneSearchField(): boolean {
    return (
      this.searchCompanyCode.trim() !== '' ||
      this.searchFacilityCode.trim() !== ''
    );
  }

  loadList() {
    if (!this.hasAtLeastOneSearchField()) {
      this.toastrService.warning('업체코드 또는 시설코드 중 하나 이상 입력 후 조회하세요.', '');
      this.loading = false;
      return;
    }

    this.loading = true;
    this.selectedRow = null;

    const params = {
      companyCode: this.searchCompanyCode.trim(),
      facilityCode: this.searchFacilityCode.trim(),
    };

    this.receptionService.getInspectionReportCopyList(params).then(response => {
      this.loading = false;
      if (response.ResultCode) {
        this.list = Array.isArray(response.data) ? response.data : [];
      } else {
        this.list = [];
        this.toastrService.error(response.ResultMessage || '목록을 불러오지 못했습니다.', '');
      }
    }).catch(() => {
      this.loading = false;
      this.list = [];
    });
  }

  selectRow(row: any) {
    this.selectedRow = row;
  }

  isSelectedRow(row: any): boolean {
    if (!row || !this.selectedRow) {
      return false;
    }
    return String(this.selectedRow.reportSeq) === String(row.reportSeq);
  }

  trackByReportSeq(_index: number, row: any): any {
    return row ? row.reportSeq : _index;
  }

  copyApply() {
    if (!this.selectedRow || this.selectedRow.reportSeq == null || this.selectedRow.reportSeq === '') {
      this.toastrService.warning('복사할 검사표 한 건을 선택하세요.', '');
      return;
    }
    if (this.targetReceptionSeq == null || String(this.targetReceptionSeq).trim() === '') {
      this.toastrService.error('대상 접수(현재 검사표) 정보가 없습니다.', '');
      return;
    }

    if (this.selectedRow.facilityCode == null || String(this.selectedRow.facilityCode).trim() === '') {
      this.toastrService.warning('선택한 행에 시설코드가 없습니다.', '');
      return;
    }

    this.copying = true;
    this.receptionService.setInspectionReportCopy({
      targetReceptionSeq: this.targetReceptionSeq,
      sourceReportSeq: this.selectedRow.reportSeq,
      facilityCode: this.selectedRow.facilityCode
    }).then(response => {
      this.copying = false;
      if (response.ResultCode) {
        this.toastrService.success(response.ResultMessage || '검사표가 복사되었습니다.', '');
        this.activeModal.close(true);
      } else {
        this.toastrService.error(response.ResultMessage || '검사표 복사에 실패했습니다.', '');
      }
    }).catch(() => {
      this.copying = false;
    });
  }

  close() {
    this.activeModal.dismiss();
  }
}
